import { InputRow } from './InputRow';

export function ApplicationDate({ type, inputs }) {
  return inputs ? (
    <InputRow
      name={`${type} Input Month / Year`}
      value={[inputs.applicationMonth, inputs.applicationYear]
        .filter(Boolean)
        .join('/')}
    />
  ) : null;
}
